<template>
    <div class="cart-summary">
        <div class="divide-y divide-grey-border" v-bind:class="(collapsed) ? 'collapsed' : ''">
            <div v-for="participant in cart" :key="participant.id" class="participant">
                <div>
                    <div class="summary-left">
                        <span>1 {{ participant.type }} <p v-if="participant.description">({{ participant.description }})</p></span>
                        <span v-if="checkPrice(participant.price, participant.original_price)" class="block text-info text-sm">{{ $t("when.reduced") }}</span>
                    </div>
                    <div class="summary-right">
                        <span v-bind:class="checkPrice(participant.price, participant.original_price)? 'line-through text-sm text-grey-text' : ''">{{participant.original_price | money}}</span>
                        <span v-if="checkPrice(participant.price, participant.original_price)" class="block text-info">{{ participant.price | money }}</span>
                    </div>
                </div>
                <div v-for="extra in participant.extras" :key="extra.id" class="extras">
                    <div class="summary-left">
                        <span>{{ translate(extra, 'name') }}</span>
                    </div>
                    <div class="summary-right">
                        <span>{{ extra.price | money }}</span>
                    </div>
                </div>
                <div v-if="participant.keycard" class="extras">
                    <div class="summary-left">
                        <span>{{ $t("people.keycard") }}</span>
                    </div>
                    <div class="summary-right">
                        <span>{{ participant.keycard | money }}</span>
                    </div>
                </div>
            </div>
            <hr class="border-t-1">
        </div>
        <div class="price  ">
            <div class="pt-4 pb-2" v-if="promoActive">
                <div class="summary-left">
                    <span>{{promoCode.name}}</span>
                </div>
                <div class="summary-right">
                    <span class="text-info">{{-Math.abs(this.promoPrice) | money}}</span>
                </div>
                <div id="promo-added" class="pt-2">
                    <div class="bg-info rounded p-2 text-center">
                        <span class="text-white">{{ $t("review.promotion.added") }}</span>
                    </div>
                </div>
            </div>
            <div class="total-price ">
                <div class="summary-left">
                    <span class="description">{{ $t("review.total") }}</span>
                </div>
                <div class="summary-right">
                    <span class="text-2xl">{{ totalPriceFormatted.substring(0, totalPriceFormatted.indexOf(",")) }}</span>
                    <span class="total">{{ totalPriceFormatted.substring(totalPriceFormatted.indexOf(","), totalPriceFormatted.length) }}</span>
                </div>
            </div>
            <div>
                <div class="summary-left">
                    <span>{{ $t("review.subtotal") }}</span>
                </div>
                <div class="summary-right">
                    <span>{{ subtotal | money }}</span>
                </div>
            </div>
            <div class="tax">
                <div class="summary-left">
                    <span class="description">{{ taxDescription }}</span>
                </div>
                <div class="summary-right">
                    <span>{{ totalTax | money }}</span>
                </div>
            </div>
        </div>
        <div class="show-more">
            <div @click="collapse">
                <span class="description">{{ show }}</span>
                <span class="material-icons icon">{{ closed }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import i18n from '@/i18n';
    import { mapGetters } from 'vuex';
    import { translate }  from '@/helpers/translationsHelpers.js';

    export default {
        name: "CartSummary",
        data: function() {
        return {
            i18n: i18n,
            showModal: false,
            collapsed: false
        }
        },
        computed: {
            ...mapGetters('order', ['details', 'totalPrice', 'totalPricePromo', 'totalTax']),
            ...mapGetters('resort', ['resort', 'selectedProduct', 'participantById']),
            ...mapGetters('prices', ['extraPrice', 'keycard', 'productPrice', 'originalPrice', 'promoCode', 'promoPrice', 'promoActive']),
            closed: function() {
                return this.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
            },
            show: function() {
                return this.collapsed ? i18n.t('review.more') : i18n.t('review.less')
            },
            subtotal: function() {
                return this.totalPrice - this.totalTax
            },
            taxDescription: function() {
                return `${i18n.t('review.vat')}`
            },
            cart: function() {
                return this.details.map((detail) => {
                    const participantToGetTranslation = this.participantById(detail.participant_id);
                    const participantType = translate(participantToGetTranslation, 'name')
                    const participantDescr = translate(participantToGetTranslation, 'description')
                    
                    let keycard = null;
                    if (detail.keycard.new != undefined) {
                        keycard = this.keycard['best_prices'][detail.participant_id].best_amount
                        if (detail.date != null) {
                            keycard = this.keycard[detail.date][detail.participant_id].best_amount
                        }
                    }

                    return {
                        id: detail.participant_id,
                        type: participantType, 
                        description: participantDescr,
                        original_price: this.originalPrice(detail.date, detail.participant_id),
                        price: this.productPrice(detail.date, detail.participant_id),
                        extras: detail.extras.map(extra => {
                            const currentExtra = this.selectedProduct.extras.find(ext => ext.id === extra);
                            currentExtra.price = this.extraPrice(extra, detail.participant_id)
                            return currentExtra
                        }),
                        keycard: keycard, // (detail.keycard.new != undefined) ? (detail.date != null ? this.keycard[detail.date][detail.participant_id].best_amount : this.keycard['best_prices'][detail.participant_id].best_amount) : null
                    }
                })
            },
            totalPriceFormatted: function(){
                return this.$options.filters.money(this.totalPricePromo)
            }
        },
        methods: {
            collapse: function(){
                this.collapsed = !this.collapsed
            },
            translate(object, field) {
                return translate(object, field)
            },
            checkPrice(price, original_price){
                return price !== original_price
            }
        }
    }
</script>

<style scoped>
    span {
        @apply font-medium;
    }

    .cart-summary {
        @apply bg-white p-6 pb-0 border-b-1 border-grey-border;
    }

    .price {
        @apply pb-2;
    }

    .summary-left {
        @apply w-6/12 inline-block;
    }

    .summary-right {
        @apply w-6/12 inline-block text-right align-top;
    }

    .tax {
        @apply text-grey-text;
    }

    .tax .description {
        @apply font-light !important;
    }

    .total-price {
        @apply pt-4;
    }

    .total-price .description {
        @apply uppercase;
    }

    .total-price .total {
        @apply text-lg;
    }

    .participant {
        @apply pt-4 pb-4;
    }

    .extras {
        @apply block pt-2;
    }

    .show-more {
        @apply border-grey-border border-t-1 pb-4;
    }

    .show-more div {
        @apply pt-2 cursor-pointer;
    }

    .show-more .description {
        @apply text-secondary text-sm font-light;
    }

    .show-more .icon {
        @apply text-grey-text float-right;
    }

    .collapsed{
        @apply h-0 overflow-hidden;
        transition: height 0.2s ease-out;
    }

    #promo-added{
        @apply relative;
    }
    #promo-added:before{
        content: "";
        top: -12px;
        right: 10px;
        border: solid 15px transparent;
        border-bottom-color: #09c6af;
        @apply z-5 absolute;
    }
</style>